import { sys } from '@/Core/utils/system';
import { fetcher, useAPIMutation } from '@/api/api';
import { IFAwardListRsp, IFAwardTotalInfoRsp, IFMyAwardListRsp, IFSpecialAwardListRsp } from "@/api/apiRsp/IFAwardRsp";
import { useEffect } from 'react';
import useSWR, {mutate} from 'swr';
import { useActivityEntryPlus } from './home';
import { useGlobalState } from './commonStore';
import { getBonusMyAwardListSWRKey } from './bonusKeys';

export class SWRBonusKey {
   
  //领奖记录
  public static get historyKey(){
    return `historyBonus?${sys.token}`
  }
}
//
export function useBonusAwardTotalInfoPlus() {
  const fetch = ()=> {
    return  fetcher<IFAwardTotalInfoRsp>({ path: '/api/vip/awardTotalInfo', type: 'get' }, {})
  }
  return useSWR<IFAwardTotalInfoRsp>('awardTotalInfo',fetch,{
    dedupingInterval: 1000 
  })
}

//获取领奖记录
export function useBonusAwardHistoryListPlus() {
  const fetch = ()=> {
    return  fetcher<IFAwardListRsp[]>({ path: '/api/vip/historyAwardList', type: 'post' }, { arg: {pageNum: 1, pageSize: 10} })
  }
  return useSWR<IFAwardListRsp[]>(SWRBonusKey.historyKey,fetch)
}

//获取vip数据列表
export function useBonusMyAwardListPlus() {
  const { isLogin, token } = useGlobalState();
  const fetch = () => {
    return fetcher<IFMyAwardListRsp>({ path: '/api/vip/myAwardList', type: 'get'}, {})
  }
  return useSWR<IFMyAwardListRsp>(getBonusMyAwardListSWRKey(token, isLogin),fetch,{dedupingInterval: 1000 })
}

//通知消息
export function clearBonusMyAwardListPlus() {
  const key = getBonusMyAwardListSWRKey(sys.token, !!sys.token);
  if (key) {
    mutate(key,null,{revalidate:true})
  }
}

//获取玩家特殊奖励领取列表
export function useBonusSpecialAwardList() {
  const fetch = () => {
    return fetcher<IFSpecialAwardListRsp[]>({ path: '/api/vip/mySpecialAwardList', type: 'get' }, {})
  }
  return useSWR<IFSpecialAwardListRsp[]>('bonusSpecialAwardList',fetch,{dedupingInterval: 1000 })
}

//奖励领取
export function useBonusGetVipAward() {
  const { data, trigger } = useAPIMutation<any, any>({ path: '/api/vip/getVipReward', type: 'post' });
  const { mutate } = useActivityEntryPlus(false)
  useEffect(()=>{
    if(data) {
      mutate()
    }
  },[data])

  return {
    data,
    trigger,
  };
}
